import { useState } from "react";
import { api } from "@/lib/api";

// Shared constants + hooks used by Finance subsection tabs.
export const BANK_ACCOUNTS = ["Premier Bank", "Amal Bank", "Salaam Bank", "Dahabshiil Bank"];

export function useUpload() {
  const [busy, setBusy] = useState(false);
  const upload = async (file) => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/finance/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    } finally {
      setBusy(false);
    }
  };
  return { upload, busy };
}
